export default {
  INTEGRATOR: 'INTEGRATOR',
  THIRD_PARTY: 'THIRDPARTY',
};
